import {IComponentOptions} from "angular";
import {getEditableFieldConfiguration} from "../editable-field.component";
import {IEditableField} from "../IEditableField";


export class BooleanEditableFieldComponent extends IEditableField{
    public static instance: IComponentOptions = getEditableFieldConfiguration(
        require('./boolean-editable-field.component.html'),
        [BooleanEditableFieldComponent]
    );

}